import request from "@/router/axios"
export const reserve = (data) => {
    return request({
        url: `/api/jy/record/bill/reserve`,
        method: 'post',
        data: data
    })
}
export const getInspectApply = (patientId, startDate, endDate) => {
    return request({
        url: `/api/jy/record/bill/getInspectApply`,
        method: 'get',
        params: {
            patientId: patientId,
            startDate: startDate,
            endDate: endDate,
        }
    })
}